import axios, { encodeData } from "../utils/axios";

export const createYourParavolo = async (data) => {
  const res = await axios.post("/eParavolo/createParavolo", encodeData(data));
  return res;
};

export const getParavoloStatus = async (data) => {
  const res = await axios.post(
    "/eParavolo/getParavoloStatus",
    encodeData(data)
  );
  return res;
};

export const useParavolo = async (data) => {
  const res = await axios.post("/eParavolo/useParavolo", encodeData(data));
  return res;
};
